// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3HZBD","title":"Info_title__DCi-e","links":"Info_links__2TRew","link":"Info_link__TzPTK","logo":"Info_logo__NA_wY"};